// import { RouterProvider } from 'react-router-dom'
// import { router } from './routes/paths/routes'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '@/redux-store/store/store'
import NewApp from '@/designs/new/NewApp'
import AppToaster from '@/designs/new/components/ui/toaster/AppToaster'

const App: React.FC = () => {
  const fontChangePx = useSelector(
    (state: RootState) => state.menu.fontChangePx,
  )

  useEffect(() => {
    document.documentElement.style.fontSize = `calc(100% + ${fontChangePx}px)`
  }, [fontChangePx])

  useEffect(() => {
    if (localStorage.getItem('design-preference-v2')) {
      localStorage.removeItem('design-preference-v2')
    }
    if (localStorage.getItem('design-preference')) {
      localStorage.removeItem('design-preference')
    }
  }, [])

  return (
    <>
      <AppToaster />
      <NewApp />
    </>
  )
  // React Router v7 will automatically wrap state updates in React.startTransition, which helps with performance (especially for data fetching/navigation). Right now, you can opt-in early using a future flag:
}

export default App
